import React from 'react';

const ServerUnavailable: React.FunctionComponent = () => <h2>503 - Server Unavailable</h2>;

export default ServerUnavailable;
